const CheckQuyenTuXuLy = (quyenTuXuLyInfo) => {

  let check = false;

  if (quyenTuXuLyInfo && localStorage.getItem('userInfo')) {

    let data = JSON.parse(localStorage.getItem('userInfo'));

    if (data.loaiVaiTroMacDinh == "LANH_DAO" || data.loaiVaiTroMacDinh == "TRUONG_PHONG") {
      quyenTuXuLyInfo.map((item, i) => {
        if (item.donViId == data.donViId) {
          check = item.quyenTuXuLy;
        }
      })
    }
  }
  return check;
}

export { CheckQuyenTuXuLy };


// WEBPACK FOOTER //
// ./src/components/modules/login/CheckQuyenTuXuLy.js